import { createContext, useContext, useEffect, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [googleUser, setGoogleUser] = useState(() => {
    const stored = localStorage.getItem("googleUser");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (googleUser) {
      localStorage.setItem("googleUser", JSON.stringify(googleUser));
    } else {
      localStorage.removeItem("googleUser");
    }
  }, [googleUser]);

  return (
    <UserContext.Provider value={{ googleUser, setGoogleUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
